import React from 'react';
import irelandApi from '../irelandApi';
import { actions } from 'react-redux-form';
import { toast } from 'react-toastify';
import store, { history } from '../store';
import ToastMessage from '../components/common/toast-message';
import {getOrderNow, updateDeliveryAddress} from './orders';
import { getMyProfile } from './user';
import setAuthorizationToken from '../utils/tokenUtils';
import {toInt} from '../utils/commonFunctions'

const HO_ACCOUNTS_URL = '/api/admin/ho_accounts';

export const getAdminHoAccounts = (filter = '', page = '') => dispatch => {
  dispatch({
    type: 'GET_HO_ACCOUNTS_PENDING',
    payload: []
  });
  return irelandApi
    .get(HO_ACCOUNTS_URL, { params: { q: filter, page: page } })
    .then(response => {
      dispatch({
        type: 'GET_ADMIN_HO_ACCOUNTS_FULFILLED',
        payLoad: response.data
      });
    })
    .catch(error => {
      dispatch({
        type: 'GET_HO_ACCOUNTS_REJECTED',
        payLoad: error.data
      });
      return Promise.reject(error.response.data);
    });
};

export const getHoAccount = (id) => (dispatch) => {
  dispatch({type: 'GET_HO_ACCOUNT_PENDING'});
  return irelandApi.get(`${HO_ACCOUNTS_URL}/${id}`)
    .then((response) => {
      const attributes = response.data.data.attributes;
      const payload = {
        data: {
          attributes: {
            ho_account_number: attributes['ho-account-number'],
            active: '' + attributes['active'],
          }
        }
      };

      dispatch({
        type: 'GET_HO_ACCOUNT_FETCHED',
        payLoad: payload
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_HO_ACCOUNT_REJECTED',
        payLoad: error.response
      })
    })
};

export const saveHoAccount = (payLoad, _) => {
  return irelandApi.post(HO_ACCOUNTS_URL, {ho_account: payLoad})
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="HO Account has been saved successfully"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Error while saving HO Account"/>);

      const errorData = error.hasOwnProperty('response') ? error.response.data.errors : [];

      return Promise.reject(errorData);
    })
};

export const updateHoAccount = (id, payLoad, _) => {
  return irelandApi.patch(`${HO_ACCOUNTS_URL}/${id}`, {ho_account: payLoad})
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="HO Account has been saved successfully"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Error while saving HO Account"/>);

      const errorData = error.hasOwnProperty('response') ? error.response.data.errors : [];

      return Promise.reject(errorData);
    }).then(() => {
      history.push('/admin/ho-accounts');
    });
};



// WEBPACK FOOTER //
// ./src/actions/ho-accounts.js